var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWater02 = function SvgWater02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "water-02_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#water-02_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.094 11.122a3.048 3.048 0 0 1-2.094.852c-.745 0-1.49-.285-2.094-.852a2.954 2.954 0 0 1 0-4.152L12 4.876l2.094 2.094c1.135 1.135 1.135 2.98 0 4.152Zm-4.19 6.627a3.048 3.048 0 0 1-2.094.852c-.746 0-1.49-.284-2.094-.852a2.954 2.954 0 0 1 0-4.152l2.094-2.094 2.094 2.094c1.135 1.135 1.135 2.981 0 4.152Zm6.286.733c.746 0 1.49-.284 2.094-.852 1.136-1.17 1.136-3.016 0-4.152l-2.094-2.094-2.094 2.094a2.954 2.954 0 0 0 0 4.152 3.048 3.048 0 0 0 2.094.852Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "water-02_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgWater02 as ReactComponent };